<template>
	<div class="hello_container">
		<div class="swiper_container">
			<el-carousel class="swiper_list" :interval="swiperSpeed" arrow="never">
				<el-carousel-item v-for="(item, index) in swiperList" :key="index">
					<!-- <div class="swiper_item" :style="backgroundImageStyle(index+1)"> -->
					<div class="swiper_item" v-lazy:background-image="require('@/assets/static/imgs/home/m/index-bg-b' + (index+1) + '.png')">
						<div class="swiper_item_content" :class="`zdyConSty${index+1}`">
							<h1 v-if="false">{{ item.title }}</h1>
							<p v-if="false">{{ item.subTitle }}</p>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
/**
 * Pc Components AllGamesBanner
 * @ is an alias to /src
 */
export default {
	name : 'AllGamesBannerPc',
	props: {
		msg: String,
	},
	data() {
		return {
			swiperSpeed: 10000,
			swiperList : [
				{
					title   : 'Egypt Slot',
					subTitle: 'Explore the mysterious Egyptian pyramids'
				},
				{
					title   : 'Fishing Star',
					subTitle: 'Interesting Fishing Experience'
				},
				{
					title   : 'Jurassic',
					subTitle: 'Take you back to the dinosaur era'
				}
			]
		}
	},

	methods: {
		// 动态添加背景图
		backgroundImageStyle(i)
		{
			const imageUrl = require(`@/assets/static/imgs/home/index-bg-b${i}.png`);
			return {
				// 'background-image'   : `url(${imageUrl})`,// 使用 require 导入图片路径
				'background-position': 'center top',      // 设置背景图片位置
				'background-repeat'  : 'no-repeat',       // 设置背景图片是否重复
				// 'background-size' : '212px 202px',     // 设置背景图片填充方式
			};
		},
		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.hello_container{
	position:relative;
	background:transparent;
	width:100%;height:var(--com-base-top-container-h2);
	.swiper_container{
		width:inherit;height:inherit;
		.swiper_list{
			width:inherit;height:inherit;
			/deep/ .el-carousel__container{
				width:inherit;height:inherit;
				.el-carousel__item{
					height:inherit;
				}
			}
			/deep/ .el-carousel__indicators--horizontal{
				bottom:20px;left:0;right:0;margin:auto;transform:translateX(35%);
				button.el-carousel__button{
					opacity:.8;
					width:15px;height:10px;
					border-radius:50px;
					background:#D6C69C;
				}
				.is-active{
					button.el-carousel__button{
						opacity:1;
						width:35px;
						background:#FFF;
						/* background:linear-gradient(var(--gradient-direction), var(--gradient-color-start), var(--gradient-color-end)); */
					}
				}
			}
			.swiper_item{
				width:inherit;height:inherit;
				background-size:750px 760px;
				padding-top:64px;
				position:relative;
				.swiper_item_content{
					width:375px;height:auto;/* height:calc(var(--com-base-top-container-h2) - 64px); */

					position:absolute;top:320px;left:0px;
					h1{
						font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-60);color:#FFF;
						text-align:center;line-height:1.5;
					}
					p{
						font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-28);
						text-align:center;line-height:1.5;
					}
				}
				.zdyConSty1{
					p{
						color:#F9EAA3 !important;
					}
				}
				.zdyConSty2{
					p{
						color:#9ED3FF !important;
					}
				}
				.zdyConSty3{
					p{
						color:#E0FF9E !important;
					}
				}
			}
		}
	}
}

@keyframes aniRotateRight{
	0%{
		-webkit-transform:rotate(0deg);
		transform:rotate(0deg);
	}
	50%{
		-webkit-transform:rotate(180deg);
		transform:rotate(180deg);
	}
	100%{
		-webkit-transform:rotate(1turn);
		transform:rotate(1turn);
	}
}
@keyframes aniUp-c0{
	0%{
		top:30px;
		opacity:0;
	}
	50%{
		top:90px;
		opacity:1;
	}
	75%{
		top:90px;
		opacity:1;
	}
	100%{
		top:90px;
		opacity:0;
	}
}
@keyframes aniDown-c0{
	0%{
		bottom:-30px;
		opacity:0;
	}
	50%{
		bottom:-5px;
		opacity:1;
	}
	75%{
		bottom:-5px;
		opacity:1;
	}
	100%{
		bottom:-5px;
		opacity:0;
	}
}
</style>
